module.exports = __webpack_public_path__ + "media/images/bg_book_mv_sp-63cfd384965489967fc2206f02a5f6f1.jpg";